import '../chart_view.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.CountriesChartView extends Monitoring.Views.Charts.ChartView

  className: 'processing'

  events:
    'click #close_chart': 'destroy'
    'click #save_note': 'saveNote'
    'click #delete_note': 'deleteNote'
    'click .insert-note': 'displayNote'

  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery
    @facets = @options.facets
    @container = @options.container

  _dataIsEmpty: ->
    @getCountriesMapData().length == 0

  render: ->
    google.load('visualization', '1', { callback: @renderChart, 'packages': ['geochart'] })
    return this

  renderChart: =>
    @$el.removeClass('processing')
    @$el.append($('<div id="countriesMap"></div>'))

    data = google.visualization.arrayToDataTable(
      [
        ['Country', 'Count']
      ].concat(@getCountriesMapData())
    );
    options =
      displayMode: "regions"
    geomap = new google.visualization.GeoChart(@$el.find("#countriesMap").get(0))
    geomap.draw(data, options)

    google.visualization.events.addListener(geomap, 'select', (a) =>
      selection = geomap.getSelection()
      value = data.getValue(selection[0].row, 0)
      geomap.setSelection(null)
      @_previewSearch(value)
    )
    @finish()

  _previewSearch: (value) ->
    @createPreviewDashboard(@getNewQuery(value))

  getNewQuery: (value) ->
    query = @searchQuery.deepCopy()
    query.set('countries', [])
    query.addCountry(value)
    return query

  getCountriesMapData: ->
    return _.collect(@facets['country']['terms'], (value) ->
      [value.term, value.count]
    )

  destroy: ->
    @$el.html('')
    @remove()
